import { Injectable } from '@angular/core';
import { SellerApiService } from './seller-api.service';
import { KitchenModal } from '../sub-component/kitchenmodal';

@Injectable()
export class CommonPdfService {
  kitchen: KitchenModal;
  constructor(private sellerService: SellerApiService) {

  }

  // Get the Project Information using projectID and Seller User Id. (Categories Scope and Details )
  getServiceRequestByprojectId(project_id, user_id): any {
    this.kitchen = new KitchenModal();
    this.sellerService.getServiceRequestDetailsByProjectId(project_id, user_id).subscribe(res => {
      if (res != null) {
        this.kitchen = this.toObject(res);
      }
      return this.getgeneratedpdf();
    }, err => {
      console.log(err);
      return null;
    });
  }
  // to convert to Kitchen Modal Here
  toObject(arr) {
    // tslint:disable-next-line:prefer-const
    let kitchn = new KitchenModal();
    for (let i = 0; i < arr.length; ++i) {
      if (Object.values(arr[i])[0] === 'False') {
        kitchn[Object.keys(arr[i])[0]] = false;
      } else if (Object.values(arr[i])[0] === 'True') {
        kitchn[Object.keys(arr[i])[0]] = true;
      } else {
        kitchn[Object.keys(arr[i])[0]] = Object.values(arr[i])[0];
      }
    }
    return kitchn;
  }

  getgeneratedpdf() {
    // tslint:disable-next-line:prefer-const
    let scopeDetailsPdf = '<!doctype html>' +
      '<html lang="en">' +
      '  <head>' +
      '    <!-- Required meta tags -->' +
      '    <meta charset="utf-8">' +
      '    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">' +
      '' +
      '    <!-- Bootstrap CSS -->' +
      // tslint:disable-next-line:max-line-length
      '    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">' +
      '' +
      '    <title>Hantverkarformuläret - 17</title>' +
      '  </head>' +
      '  <body>' +
      '    <div class="container-fluid">' +
      '      <!-- section A -->' +
      '      <div class="container">' +
      '        <div class="row mt-5">' +
      '          <h3>Brief</h3> </div>' +

      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Namn  <br/><span class="text-secondary">' +
      'this.agreementCreate.nameperson1' + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Personnummer <br/> <span class="text-secondary">' + 'this.agreementCreate.identitynumberperson1' + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Namn <br/><span class="pl-2 text-secondary">' + 'this.agreementCreate.nameperson2' + '</span></td>' +
      '                  <td>Personnummer <br/><span class="text-secondary">' +
      'this.agreementCreate.identitynumberperson2' + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td colspan="2">Adress <br/><span class="text-secondary">' + 'this.agreementCreate.firstStepAddress' + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Telefonnummer <br/><span class="text-secondary">' + 'optionalNumber' + '</span></td>' +
      '                  <td>E-post <br/><span class="text-secondary">' + 'this.agreementCreate.firstStepemail' + '</span></td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '        </div>' +

      '    </div>' +
      '    <!-- Optional JavaScript -->' +
      '    <!-- jQuery first, then Popper.js, then Bootstrap JS -->' +
      // tslint:disable-next-line:max-line-length
      '    <!-- <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>' +
      // tslint:disable-next-line:max-line-length
      '    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>' +
      '    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script> -->' +
      '  </body>' +
      '</html>';

    return scopeDetailsPdf;
  }





}



// WEBPACK FOOTER //
// ./src/app/seller/service/common-pdf.service.ts